module.exports = __webpack_public_path__ + "img/backrest.8a60b149.png";